import React from 'react';

import { Helmet } from 'react-helmet';

import * as T from './PageHelmet.types';

export const PageHelmet: React.FunctionComponent<T.IPageHelmetProps> = ({
  title,
  charSet = 'utf-8',
  favicon = '/favicon.ico',
  manifest = '/manifest.json',
  viewport,
  themeColor,
  ogTitle,
  ogSiteName,
  ogImage,
  ogDecription,
  otherHeadComponents,
}) => (
  <Helmet>
    <meta charSet={charSet} />
    <title>{title}</title>
    <link rel="icon" href={favicon} />
    <link rel="manifest" href={manifest} />

    {viewport && <meta name="viewport" content={viewport} />}
    {themeColor && <meta name="theme-color" content={themeColor} />}

    {ogTitle && <meta property="og:title" content={ogTitle} />}
    {ogSiteName && <meta property="og:site_name" content={ogSiteName} />}
    {ogImage && <meta property="og:image" content={ogImage} />}
    {ogDecription && <meta property="og:description" content={ogDecription} />}

    {otherHeadComponents}
  </Helmet>
);
